import {connect} from "react-redux";
import {getPropsFromState} from "../redux/mapStateToProps";
import {
    GetLanguages,
    GetStaticTexts,
    GetNews,
    GetVideo,
    GetTravel,
    GetProject,
    GetEvent,
    IsOpen,
    GetContact, GetAdvertisement
} from "../redux/actions";
import {useEffect, useState} from "react";
import moment from "moment";
import Header from "../components/header/Header";
import MobileMenu from "../components/mobileMenu/MobileMenu";
import Footer from "../components/footer/Footer";
import MobileSearch from "../components/mobileSearch/MobileSearch";
import Blogs from "../components/blogs/Blogs";


function Layout(props) {
    const {children,languages,selectedLanguage,staticTexts,isOpen} = props
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [mobileSearchOpen, setMobileSearchOpen] = useState(false)
    const [changeLanguage, setChangeLanguage] = useState(false)

    function toggleMobileMenu () {
        setMobileMenuOpen(!mobileMenuOpen)
        props.IsOpen(!mobileMenuOpen)
    }

    function toggleSearchMenu () {
        setMobileSearchOpen(!mobileSearchOpen)
    }

    function toggleLanguage() {
        setChangeLanguage(!changeLanguage)
    }

    useEffect(() => {
        moment.locale(selectedLanguage?.code)
        props.GetStaticTexts().finally(() => {
            props.GetLanguages();
            props.GetEvent();
            props.GetVideo();
            props.GetNews();
            props.GetTravel();
            props.GetProject();
            props.GetContact();
            props.GetAdvertisement();
        });

    },[selectedLanguage?.id])

    return <div className={`layout-wrapper ${isOpen ? 'fixed' : ''}`}>
        <Header mobileMenuOpen={mobileMenuOpen}
                changeLanguage={changeLanguage}
                toggleLanguage={toggleLanguage}
                toggleSearchMenu={toggleSearchMenu}
                toggleMobileMenu={toggleMobileMenu}/>
        <MobileMenu className={mobileMenuOpen ? 'expand_on' : ''}
                    mobileMenuOpen={mobileMenuOpen}
                    changeLanguage={changeLanguage}
                    toggleLanguage={toggleLanguage}
                    toggleMobileMenu={toggleMobileMenu}/>
        <MobileSearch className={mobileSearchOpen ? 'expand_on' : ''}
                      mobileSearchOpen={mobileSearchOpen}
                      toggleMobileMenu={toggleMobileMenu}
                      toggleSearchMenu={toggleSearchMenu}/>
        <Blogs/>
        <div>
            {children}
        </div>
        <Footer mobileMenuOpen={mobileMenuOpen}
                toggleMobileMenu={toggleMobileMenu}/>
    </div>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'languages',
        'selectedLanguage',
        'staticTexts',
        'isOpen',
    ])
};

const mapDispatchToProps = {
    GetLanguages,
    GetStaticTexts,
    GetEvent,
    GetVideo,
    GetNews,
    GetTravel,
    GetProject,
    GetContact,
    GetAdvertisement,
    IsOpen
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
